var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg font-weight-medium"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value,
      isActive = _ref.isActive;
    return _c('v-btn', {
      key: value,
      staticClass: "mt-10",
      class: isActive ? '' : 'grey-6--text',
      attrs: {
        "block": "",
        "outlined": "",
        "color": isActive ? 'primary' : 'grey-9',
        "elevation": isActive ? 1 : undefined
      },
      on: {
        "click": function ($event) {
          return _vm.toggle(value);
        }
      }
    }, [_c('v-row', {
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-simple-checkbox', {
      attrs: {
        "value": isActive,
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          return _vm.toggle(value);
        }
      }
    })], 1), _c('v-col', {
      staticClass: "text-start"
    }, [_vm._v(_vm._s(text))])], 1)], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }